import api from "./client";

import { getUser } from "../store/authStore";

import {
  getSelectedClinicId,
} from "../store/selectedClinicStore";

const resolveClinicId = () => {

  const user = getUser();

  // clinic role
  if (user?.role === "clinic") {
    return user?.clinic_id || user?.clinic;
  }

  // inspector roles
  return getSelectedClinicId();
};

// ✅ Получение паспорта
export const getPassport = () => {

  const clinicId = resolveClinicId();

  if (!clinicId) {
    throw new Error("Нет выбранной клиники");
  }

  return api.get(`/api/passport/full/${clinicId}/`);
};

// ✅ Сохранение паспорта
export const savePassport = (data) => {

  const clinicId = resolveClinicId();

  if (!clinicId) {
    throw new Error("Нет выбранной клиники");
  }

  return api.post(
    "/api/passport/save/",
    {
      ...data,
      clinic_id: clinicId,
    }
  );
};
